// @flow

import * as React from 'react';
import { defineMessages } from 'react-intl';
import { FieldWrapper } from 'speed-js-react-web';
import BaseSelect from 'esm-web-pro/components/forms/fields/BaseSelect';
import * as Yup from 'yup';
import { Box } from 'grommet';

type Props = {
    field: {
        name: string,
        value: Object | null
    },
    choices: Object,
    form: {
        setFieldValue: (string, any) => void,
    },
    required: boolean,
    label: string,
    help_text: string,
    label: string,
    objectIdLabel: string,
    objectTypeEmptyLabel?: string,
    objectIdEmptyLabel?: string,
    resourcesMap?: Object,
}

const messages = defineMessages({
    required: {
        id: 'genericobjectselect-required',
        defaultMessage: 'This field cannot be empty!',
    },
});

class GenericObjectSelect extends React.PureComponent<Props> {
    static defaultProps = {
        objectTypeEmptyLabel: null,
        objectIdEmptyLabel: null,
        resourcesMap: undefined,
    };

    changedObjectType = false;

    static getValidationSchema(field: { validation: Object }) {
        let errMsg = Yup.object().nullable();
        if (field.validation.required) {
            errMsg = Yup.object().required(messages.required).nullable();
        }
        return errMsg;
    }

    handleChange = (value: string) => {
        const {
            form: { setFieldValue }, field: { name, value: currentValue },
        } = this.props;
        const newValue = currentValue ? { ...currentValue } : {};
        newValue.object_type = value;

        setFieldValue(name, newValue);
        this.changedObjectType = true;
    };

    handleSecondChange = (value: string) => {
        this.changedObjectType = false;
        const {
            form: { setFieldValue }, field: { name, value: currentValue },
        } = this.props;

        const newValue = currentValue ? { ...currentValue } : {};
        newValue.object_id = value;

        setFieldValue(name, newValue);
    };

    secondSelectValue = (value: Object) => {
        // Fixes current selecting of wrong object_id choice when the object_type is changed
        if (value && value.object_id && this.changedObjectType) {
            return null;
        } if (value && value.object_id) {
            return value.object_id;
        }
        return null;
    };

    render() {
        const {
            choices, field: { value },
            field: { name }, required, label, help_text: help, objectIdLabel,
            objectTypeEmptyLabel, objectIdEmptyLabel, resourcesMap,
        } = this.props;

        let resourceName = value && value.object_type ? value.object_type.split('.')[1] : null;
        if (resourcesMap && typeof resourcesMap[resourceName] !== 'undefined') {
            resourceName = resourcesMap[resourceName];
        }

        const secondSelect = (
            <Box fill="horizontal">
                <BaseSelect
                    resourceName={resourceName}
                    disabled={!(value && value.object_type)}
                    onChange={this.handleSecondChange}
                    labelFields={['name']}
                    preload
                    minSearchLength={0}
                    value={this.secondSelectValue(value)}
                    emptyLabel={objectIdEmptyLabel || 'No object'}
                />
            </Box>
        );


        return (
            <FieldWrapper
                name={name}
                required={required}
                helpText={help}
                label={objectIdLabel || label}
            >
                <Box alignContent="between" direction="row" flex={false} gap="small">
                    <Box fill="horizontal">
                        <BaseSelect
                            id={name}
                            choices={choices}
                            value={value && value.object_type}
                            onChange={this.handleChange}
                            emptyLabel={objectTypeEmptyLabel || 'No object type'}
                        />
                    </Box>
                    { secondSelect }
                </Box>
            </FieldWrapper>
        );
    }
}

export default GenericObjectSelect;
